import React, { Component } from 'react'
import style from '../style.module.less'
import { inject, observer } from 'mobx-react'
import { message, Popconfirm, Tag, Input, Flex, Modal } from 'hljd'
import { MinusCircleOutlined, EditOutlined } from '@ant-design/icons'

@inject('store')
@observer
export default class extends Component {
  constructor(p) {
    super(p)
    this.state = {
      dishName: '',
      drinkName: '',
      showSmartModal: false,
      smartMenuStr: ''
    }
  }

  addDish = () => {
    const { dishName } = this.state
    if (!dishName.trim().length) {
      return message.error('请输入菜品名称')
    }
    if (dishName.trim().length > 20) {
      return message.error('菜品名称最多20个字')
    }
    console.log('dishName:', `'${dishName}'`)
    this.props.store.addDish(this.props.index, dishName)
    this.setState({
      dishName: ''
    })
  }

  addDrink = () => {
    if (this.state.drinkName) {
      this.props.store.addDrink(this.props.index, this.state.drinkName)
      this.setState({
        drinkName: ''
      })
    } else {
      message.error('请输入酒水饮料说明')
    }
  }

  onDishNameChange = v => {
    this.setState({
      dishName: v
    })
  }

  onDrinkNameChange = v => {
    this.setState({
      drinkName: v
    })
  }

  onError = (up, err, errTip) => {
    message.error(errTip)
  }
  smartEdit = () => {
    this.setState({
      showSmartModal: true
    })
  }
  onSmartMenuChange = value => {
    this.setState({
      smartMenuStr: value
    })
  }
  submitSmartMenu = () => {
    const menuStr = this.state.smartMenuStr.trim()
    if (!menuStr.length) {
      return message.error('请输入菜单')
    }
    const separator = /[,，、;；\n\s]+/
    const menu = menuStr
      .replace(/(^[,，、;；\n\s]+)|([,，、;；\n\s]+$)/g, '')
      .split(separator)
    console.log('menu:', menu)
    const validateError = menu.some(item => {
      return item.length > 20
    })
    if (validateError) {
      return message.error('有菜品名称超过20个字，请检查后重新提交')
    }
    this.props.store.addDish(this.props.index, menu)
    this.closeModal()
  }
  closeModal = () => {
    this.setState({
      showSmartModal: false
    })
    this.setState({
      smartMenuStr: ''
    })
  }
  render() {
    const { dishName, showSmartModal, smartMenuStr } = this.state
    const { index, store } = this.props
    const { menus, deleteDish, deleteMeal } = store
    const menu = menus[index]
    const { food_name } = menu

    return (
      <div className={style.form}>
        <Flex sp style={{ marginBottom: 12, marginRight: 30 }}>
          <span className={style.title}>
            {String.fromCharCode(65 + index)}套餐
          </span>
          <span
            style={{ cursor: 'pointer', color: '#999' }}
            onClick={this.smartEdit}
          >
            <EditOutlined />&nbsp;智能填写菜单
          </span>
        </Flex>
        <Flex sp style={{ marginBottom: 6, marginRight: 30 }}>
          <div className={style.drinks}>
            {food_name.map((food, i) => {
              return (
                <Tag
                  closable
                  onClose={e => {
                    e.preventDefault()
                    deleteDish(index, i)
                  }}
                  key={i}
                >
                  {food}
                </Tag>
              )
            })}
          </div>
        </Flex>
        <Flex sp>
          <Input
            placeholder="请输入菜品名称，按回车/换行键即可添加，最多20个字"
            value={dishName}
            onChange={e => this.onDishNameChange(e.target.value)}
            onPressEnter={this.addDish}
            style={{ width: 440 }}
          />
          {menus.length > 1 && (
            <Popconfirm
              okText="是"
              cancelText="否"
              placement="topLeft"
              title="确认删除该套餐吗？"
              onConfirm={deleteMeal(index)}
            >
              <MinusCircleOutlined style={{ color: '#999' }} />
            </Popconfirm>
          )}
        </Flex>
        {/* <FormItem label="菜品图片" flexStart>
          <Imgs index={index} />
          <div style={{ color: '#666' }}>
            展示在婚宴菜单详情中的图片，拖动图片调整图片顺序(默认取第一张为菜单封面图，不上传则使用默认图片）
            <span style={{ color: '#fa745e' }}>单张图片不要超过10M</span>
            ，支持JPG、PNG和BMP等常见图片格式。
          </div>
        </FormItem> */}
        <Modal
          title="智能填写菜单"
          visible={showSmartModal}
          onOk={this.submitSmartMenu}
          onCancel={this.closeModal}
          className={style.smartModal}
          width={560}
        >
          <p style={{ marginBottom: 12 }}>
            粘贴整个菜单，菜品名称间使用逗号、顿号、空格等字符间隔，即可智能识别
          </p>
          <Input.TextArea
            placeholder="例如：三羊开泰，四季平安，五福临门，六六大顺"
            value={smartMenuStr}
            onChange={e => this.onSmartMenuChange(e.target.value)}
          />
        </Modal>
      </div>
    )
  }
}
